export default function unixTimeToDateTime(unixTime: number): string {
  var dateObject = new Date(1000*unixTime);
  return dateObject.toLocaleString('es-cl', { timeZone: "UTC" });
}